module.exports = __webpack_public_path__ + "public/img/project1-3.8ce22e82.jpeg";